<template>
  <v-layout>
    <v-flex xs12 style="height:650px;" mb-4>
      <div class="images" v-viewer.static="{zoomRatio: 0.2, inline: true, navbar: true, fullscreen: false, title: false, scalable: false, keyboard: false}">
        <img v-for="img in thumbnails" :key="img.id" :src="img.route">
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import "viewerjs/dist/viewer.css"
import { mapState } from "vuex"
import Viewer from "v-viewer"
import Vue from "vue"
Vue.use(Viewer)

export default {
  name: "ImageViewer",
  props: ["field", "data"],
  data: () => {
    return {
      dummyData: [
        { id: 1, route: require("../../../assets/images/image-01.png") },
        { id: 2, route: require("../../../assets/images/image-02.png") }
      ]
    }
  },
  computed: {
    ...mapState({
      caseData: state => state.cases.currentlySelected.case
    }),
    thumbnails: {
      get() { // TODO
        if (this.data) { console.log("ImageViewer Data, ", this.data) }
        return this.dummyData
      },
      set(newThumbs) {
        this.$emit('update-item', { field: this.field.name, data: newThumbs })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>

<style>
.viewer-container {
  background-color: rgba(0, 0, 0, 0.06) !important;
}

.images {
  display: none;
  overflow: hidden;
}

.images img {
  width: 100%;
}

.viewer-backdrop {
  background: none;
}

.viewer-canvas > img {
  max-width: 100% !important;
}

.viewer-fullscreen {
  display: none;
}

.viewer-navbar {
  background-color: rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.viewer-play {
  display: none !important;
}
</style>
